import * as service from './service'
export default {
  namespace: 'levelSysExperienceDetails',
  state: {
    scoreRecordData: {
      scoreRecord: {
        record: undefined
      }
    }
  },
  effects: {
    * scoreRecord ({ payload }, { call, put }) {
      const res = yield call(service.scoreRecord, payload)
      yield put({
        type: 'save',
        payload: {
          scoreRecordData: res.data.data
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
